import { makeStyles } from "@material-ui/styles";
import Leaf from "../../images/bgleaf.png";
import Doubleq from "../../images/doubleq.png";

const styles = makeStyles((theme) => ({
    bannerwrapper: {
		position: "relative",
		margin: "auto",
		marginTop: 20,
		marginBottom: 50,
		transition: "all ease .5s",
		[theme.breakpoints.down("md")]: {
			marginBottom: 80
		},
		[theme.breakpoints.down("sm")]: {
			marginBottom: 0
		}
	},
	bwrapper: {
		maxWidth: 1700,
		margin: "auto",
		width: "90%",
		transition: "all ease .5s"
	},
	cardsmain: {
		margin: "auto",
		padding: 0,
		maxWidth: 1600,
		transition: "all ease .5s"
	},
	arrows: {
		width: 52,
		position: "relative",
		height: 52,
		margin: "auto",
		top: -70,
		transition: "all ease .5s",
		[theme.breakpoints.down("sm")]: {
			top: -20
		},
		"& span:nth-child(1)": {
			transform: "rotate(180deg)",
			position: "absolute",
			left: 0,
			cursor: "pointer"
		},
		"& span:nth-child(2)": {
			position: "absolute",
			right: 0,
			top: 3,
			cursor: "pointer",
			transition: "all ease .5s"
		}
	},
    leafwrapper: {
		backgroundImage: `url(${Leaf})`,
		width: 250,
		height: 300,
		backgroundSize: "cover",
		display: "block",
		position: "absolute",
		bottom: -150,
		left: -20,
		zIndex: -1,
		[theme.breakpoints.down("sm")]: {
			display: "none"
		}
	},
    wrapper: {
		width: "50%",
		position: "relative",
		listStyle: "none",
		float: "left",
		[theme.breakpoints.down("xs")]: {
			width: "100%"
		},
		"& p": {
			textAlign: "justify"
		},
		"&.contactwrap": {
			"& p": {
				textAlign: "inherit"
			}
		},
		"&:nth-child(even)": {
			marginTop: 200,
			[theme.breakpoints.down("xs")]: {
				marginTop: 0
			}
		},
		"&:nth-child(1)": {
			"& .leftclass": {
				position: "absolute"
			}
		},
		"&:nth-child(2)": {
			"& .leftclass": {
				textAlign: "left"
			}
		},
		"&:nth-child(3)": {
			display: "flex",
			flexDirection: "row-reverse",
			marginTop: -120,
			[theme.breakpoints.down("xs")]: {
				marginTop: 0,
				flexDirection: "unset"
			},
			"& img": {
				marginRight: -70,
				[theme.breakpoints.down("sm")]: {
					marginRight: 0
				},
				[theme.breakpoints.down("xs")]: {
					marginRight: 70
				}
			},
			"& .leftclass": {
				left: -70,
				[theme.breakpoints.down("md")]: {
					left: 0
				},
				[theme.breakpoints.down("sm")]: {
					left: -70
				},
				[theme.breakpoints.down("xs")]: {
					left: 0
				}
			}
		},
		"&:nth-child(4)": {
			display: "flex",
			flexDirection: "row-reverse",
			marginTop: 70,
			[theme.breakpoints.down("xs")]: {
				flexDirection: "unset"
			},
			"& img": {
				marginRight: -70,
				[theme.breakpoints.down("sm")]: {
					marginRight: 0
				},
				[theme.breakpoints.down("xs")]: {
					marginRight: 70
				}
			},
			"& .leftclass": {
				left: -70,
				textAlign: "left",
				[theme.breakpoints.down("sm")]: {
					left: 0
				}
			}
		}
	},
	left: {
		top: 50,
		width: "40%;",
		zIndex: 1,
		textAlign: "right",
		color: "#fff",
		position: "relative",
		float: "left",
		transition: "all ease .5s",
		"& .h1": {
			fontSize: 45,

			[theme.breakpoints.down("md")]: {
				fontSize: 30
			}
		}
	},
	right: {
		width: "60%",
		float: "right",
		transition: "all ease .5s",
		"& img": {
			maxWidth: "initial",
			float: "right",
			marginRight: 70,
			transition: "all ease .5s",
			[theme.breakpoints.down("lg")]: {
				maxWidth: "100%"
			}
		}
	},
	discover: {
		fontSize: 24,
		"& a": {
			color: "#fff",
			transition: "all ease .5s",
			textDecoration: "underline"
		},
		[theme.breakpoints.down("md")]: {
			fontSize: 20
		}
	},

	content: {
		position: "absolute",
		width: 350,
		transition: "all ease .5s",
		background: "#000000ba",
		padding: "10px 20px",
		color: "#fff",
		paddingBottom: 20,
		"& .newBrave": {
			fontFamily: "BreveSC !important"
		},
		"& p": {
			[theme.breakpoints.down("lg")]: {
				display: "-webkit-box",
				WebkitLineClamp: 10,
				WebkitBoxOrient: "vertical",
				overflow: "hidden"
			},
			[theme.breakpoints.down("md")]: {
				WebkitLineClamp: 7,

				maxHeight: 255
			},
			[theme.breakpoints.down("xs")]: {
				WebkitLineClamp: 5
			}
		},
		[theme.breakpoints.down("md")]: {
			width: 250
		},
		[theme.breakpoints.down("sm")]: {
			width: "100%"
		},
		[theme.breakpoints.down("xs")]: {
			width: 250
		}
	},
	leftAbout: {
		width: "81%",
		paddingRight: "10%",
		textAlign: "left",
		float: "left",
		"& .breve": {
			textAlign: "inherit",
		},
		[theme.breakpoints.down("xs")]: {
			width: "100%",
			paddingRight: 0,
		}
	},
	rightAbout: {
		width: "19%",
		float: "left",
		[theme.breakpoints.down("xs")]: {
			width: "100%"
		},
		"&.vision-slider": {
			"& .slick-dots": {
				display: "flex !important",
				justifyContent: "flex-end"
			}
		},
		"& .slideItem": {
			outline: "none",
			"& img": {
				width: "100%",
				[theme.breakpoints.down("xs")]: {
					height: 300,
				}
			}
		},
	},
	center: {
		"& img": {
			filter: " grayscale(1)",
			transition: "all ease .3s",
		},
		"& img:hover": {
			filter: " grayscale(0)",
			transition: "all ease .3s",
		}
	},
	tripadvisor: {
		margin: "2% 0",
		display: "flex",
		[theme.breakpoints.down("xs")]: {
			flexDirection: "column",
		},
		"&.tripadslider": {
			"& .slick-dots": {
				display: "flex !important",
				justifyContent: "flex-start"
			}
		},
		"& .left": {
			width: 960,
			height: 700,
			transition: "all ease .3s",
			[theme.breakpoints.down("md")]: {
				width: "57%"
			},
			[theme.breakpoints.down("xs")]: {
				width: "100%",
				height: "auto",
			},
			"& .slideItem": {
				height: 730,

				[theme.breakpoints.down("md")]: {
					width: "57%",
					height: 500,
				},
				[theme.breakpoints.down("xs")]: {
					width: "100%",
					height: "auto"
				},
				"& img": {
					maxWidth: "inherit",
					width: "100%",
					height: "100%"
				}
			}
		},
		"& .right": {
			textAlign: "center",
			width: 600,
			background: "rgba(248,80,50,0)",
			filter: " progid:DXImageTransform.Microsoft.gradient( startColorstr='#f85032', endColorstr='#b57d43', GradientType=0 )",
			padding: "10% 3%",
			marginLeft: -150,
			marginTop: 140,
			zIndex: 1,
			height: 700,
			color: "#fff",
			transition: "all ease .3s",
			display: "flex",
			justifyContent: "center",
			flexDirection: "column",
			[theme.breakpoints.down("md")]: {
				width: "50%",
				height: 500,
			},
			[theme.breakpoints.down("xs")]: {
				width: "100%",
				height: "auto",
				marginLeft: "inherit",
				marginTop: "inherit",
			}
		},
	},
	captionQ: {
		backgroundImage: `url(${Doubleq})`,
		height: 34,
		backgroundRepeat: "no-repeat",
		"&.last": {
			transform: "rotate(180deg)",
		}
	},
	captionA: {
		color: "#a5731c",
		fontSize: 14,
		fontWeight: 'bold'	
	},
	centerBlog: {
		padding: "1% 20%",
		transition: ".3s",
		[theme.breakpoints.down("xs")]: {
			padding: "1% 1%"
		}
	},
	careersCenter: {
        padding: "1% 20%",
        transition: ".3s",
        textAlign: "center",
        [theme.breakpoints.down("md")]:{
            padding: "1% 10%",
        },
        [theme.breakpoints.down("xs")]:{
            padding: "1% 5%",
        }
    },
    careersTable: {
        width: 1100,
        margin: "60px auto",
        [theme.breakpoints.down("md")]:{
            width:"100%",
        }
    },
    careersTr:{
        borderBottom: "1px solid #000",
        height: 60,
        display: "flex",
        justifyContent: "space-between",
        padding: "15px 0",
        "& td:last-child":{
            textAlign:"right"
        }
    },
	imgWidth: {
        marginBottom:50,
        "& img": {
            maxWidth:"initial"
        }
    },
	selectText: {
		textAlign: 'center',
		paddingBottom: 10,
	},
	sub: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		"& strong": {
			display: "flex",
			margin: "5px 0"
		},
		"& img": {
			height: 30,
			marginRight: 10
		}
	},
	cardsmain: {
		margin: "auto",
		padding: 0,
		maxWidth: 1200,
		transition: "all ease .5s",
		margin: "3% auto",
		width: "90%"
	},
	secMB: {
			marginBottom: 100
	}
}));
export default styles;
